// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","379":"1bfc9850"}[chunkId] + "-" + {"293":"cced5748e47bf3a560bb","379":"f6a436980e154fcedd8c"}[chunkId] + ".js";
};